import { TableHeading } from "../../../../components/common/table/TableDesign";
import { siteType } from "../../storageComponent/storageFields";

const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
};

export const SITE_FIELDS = [
  {
    id: "siteName",
    label: "Site Name",
    type: "text",
    isRequired: true,
    placeholder: "Enter site name",
    md: 4,
    section: "siteDetails",
  },
  {
    id: "address",
    label: "Address",
    placeHolder: "Enter street",
    type: "text",
    isRequired: true,
    inputProps: { maxLength: 300 },
    md: 8,
    section: "siteDetails",
  },
  {
    id: "postcode",
    label: "Post Code",
    placeHolder: "Enter postcode",
    type: "text",
    inputProps: { maxLength: 8 },
    isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 4,
    section: "siteDetails",
  },
  {
    id: "status",
    label: "Status",
    type: "select",
    options: ["Active", "InActive"],
    md: 4,
    section: "siteDetails",
  },
  {
    id: "siteType",
    label: "Type Of Site",
    type: "select",
    isRequired: true,
    options: [...siteType],
    md: 4,
    section: "siteDetails",
  },
  {
    id: "phone",
    label: "Telephone Number",
    placeHolder: "Enter phone number",
    type: "contact",
    md: 4,
    inputProps: { maxLength: 11 },
    patternAllowed: patternConstant?.NUMERIC,
    section: "siteDetails",
  },
  {
    id: "numberOfUnits",
    label: "Number Of Units",
    type: "number",
    required: false,
    min: 1,
    md: 4,
    section: "siteDetails",
  },

  {
    id: "numberOfFloors",
    label: "Number of Floors",
    type: "number",
    min: 1,
    max: 10,
    md: 3,
    section: "layoutMapping",
  },
  {
    id: "numberOfAisles",
    label: "Number of Aisles",
    type: "number",
    min: 1,
    md: 3,
    section: "layoutMapping",
    helperText: "Defines the main walking/driving paths per floor.",
  },
  {
    id: "numberOfRowsPerAisle",
    label: "Rows per Aisle",
    type: "number",
    min: 1,
    md: 3,
    section: "layoutMapping",
    helperText:
      "Standard setup is usually 2 (left row and right row facing the aisle).",
  },
  {
    id: "numberOfBaysPerRow",
    label: "Bays per Row",
    type: "number",
    min: 1,
    md: 3,
    section: "layoutMapping",
    helperText:
      "Sets how many vertical rack columns run down the length of each row.",
  },
];

export const STATUS_OPTIONS = [
  { value: "AVAILABLE", label: "Available", color: "#22A06B", bg: "#E9F7EF" },
  { value: "OCCUPIED", label: "Occupied", color: "#B71D18", bg: "#FBEAE9" },
  { value: "SELF-STORAGE", label: "Self-storage", color: "#1976D2", bg: "#E8F1FC" },
  { value: "NOT TO RENT", label: "Not to rent", color: "#212B36", bg: "#F0F1F2" },
  { value: "DAMAGED", label: "Damaged", color: "#919EAB", bg: "#F4F5F6" },
  { value: "UNSURE", label: "Unsure", color: "#B76E00", bg: "#FDF2E3" },
];

export const TABLE_HEADINGS: TableHeading[] = [
  { label: "Unit Numbering / Ref No", align: "left" },
  { label: "Size", align: "left" },
  { label: "Rent Type", align: "left" },
  { label: "Price per Unit", align: "left" },
  // { label: "Customer Name", align: "left" },
  { label: "Anticipated Moving Date", align: "left" },
  { label: "Status", align: "left" },
  { label: "Action", align: "left" },
  ];
